import ROOT_API from '../rootapi'
import ajax from '@/utils/ajax'
export default {
  localLogin(user) {  // 手机号/邮箱/工号 + 密码登录
    return new Promise((resolve, reject) => {
      ajax.post(ROOT_API, '/login/username', user, function (r) { // 登录正常
        resolve(r)
      }, function (err) {
        reject(err)
      })
    })
  },
  codeLogin (user) { // 验证码登录
    return new Promise((resolve, reject) => {
      ajax.post(ROOT_API, '/login/phone', user, function (r) { // 登录正常
        resolve(r)
      }, function (err) {
        reject(err)
      })
    })
  },
  getPicCode() { // 手机号/邮箱/工号 + 密码输错三次后需要获取图片验证码
    return new Promise((resolve, reject) => {
      ajax.get(ROOT_API, '/login/code', null, function (r) {
        resolve(r)
      })
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/bylBaseCenter/user/login.js